import { EventEmitter } from '@angular/core';
import { FilterSelectItem } from '../checkbox-facette/checkbox-liste/filterSelectItem';

export function isDisabled(item: FilterSelectItem, disabled: boolean) {
  return disabled || item.treffer == 0 || !item.active;
}

export function clicked(
  item: FilterSelectItem,
  checkboxClicked: EventEmitter<FilterSelectItem>
): void {
  checkboxClicked.emit(item);
}
